import settings from '../../settings';
let baseUrl = settings.apiBaseUrl;
export default {
    // Endpoints
    auth: {
        login: `${baseUrl}/api/v1/auth/login`,
        logout: `${baseUrl}/api/v1/auth/logout`,
        refresh: `${baseUrl}/api/v1/auth/refresh`,
        profile: `${baseUrl}/api/v1/auth/profile`,
        register: `${baseUrl}/api/v1/auth/register`,
        passwordChange: `${baseUrl}/api/v1/auth/password-change`,
        passwordChangeExpired: `${baseUrl}/api/v1/auth/password-change-expired`,
        verification: `${baseUrl}/api/v1/auth/verification`,

    },
    users: {
        get: `${baseUrl}/api/v1/dashboard/users`,
        post: `${baseUrl}/api/v1/dashboard/users`,
        delete: `${baseUrl}/api/v1/dashboard/users`,

    },
    categories: {
        get: `${baseUrl}/api/v1/dashboard/categories`,
        getFlat: `${baseUrl}/api/v1/dashboard/categories/flat`,
        getTree: `${baseUrl}/api/v1/dashboard/categories/tree`,
        getAttributes: `${baseUrl}/api/v1/dashboard/categories/attributes`,
        put: `${baseUrl}/api/v1/dashboard/categories/update`,
        post: `${baseUrl}/api/v1/dashboard/categories`,
        postTranslation: `${baseUrl}/api/v1/dashboard/categories/translation`,
        order: `${baseUrl}/api/v1/dashboard/categories/order`,
        delete: `${baseUrl}/api/v1/dashboard/categories`,
    },
    categoryAttributes: {
        get: `${baseUrl}/api/v1/dashboard/category-attributes`,
    },
    contents: {
        get: `${baseUrl}/api/v1/dashboard/contents`,
        getByCategorySlug: `${baseUrl}/api/v1/dashboard/contents/categories`,
        put: `${baseUrl}/api/v1/dashboard/contents/update`,
        post: `${baseUrl}/api/v1/dashboard/contents`,
        postAvailability: `${baseUrl}/api/v1/dashboard/contents/availability`,
        postTranslation: `${baseUrl}/api/v1/dashboard/contents/translation`,
        order: `${baseUrl}/api/v1/dashboard/contents/order`,
        delete: `${baseUrl}/api/v1/dashboard/contents`,
    },
    educators: {
        get: `${baseUrl}/api/v1/dashboard/educators`,
        getByCategorySlug: `${baseUrl}/api/v1/dashboard/educators/categories`,
        put: `${baseUrl}/api/v1/dashboard/educators/update`,
        post: `${baseUrl}/api/v1/dashboard/educators`,
        postAvailability: `${baseUrl}/api/v1/dashboard/educators/availability`,
        postTranslation: `${baseUrl}/api/v1/dashboard/educators/translation`,
        order: `${baseUrl}/api/v1/dashboard/educators/order`,
        delete: `${baseUrl}/api/v1/dashboard/educators`,
    },
    sliders: {
        get: `${baseUrl}/api/v1/dashboard/sliders`,
        put: `${baseUrl}/api/v1/dashboard/sliders/update`,
        post: `${baseUrl}/api/v1/dashboard/sliders`,
        postTranslation: `${baseUrl}/api/v1/dashboard/sliders/translation`,
        order: `${baseUrl}/api/v1/dashboard/sliders/order`,
        delete: `${baseUrl}/api/v1/dashboard/sliders`,
    },
    popups: {
        get: `${baseUrl}/api/v1/dashboard/popups`,
        getById: `${baseUrl}/api/v1/dashboard/popup`,
        put: `${baseUrl}/api/v1/dashboard/popup/update`,
        post: `${baseUrl}/api/v1/dashboard/popup`,
        postTranslation: `${baseUrl}/api/v1/dashboard/popup/translation`,
        order: `${baseUrl}/api/v1/dashboard/popups/order`,
        delete: `${baseUrl}/api/v1/dashboard/popup`,
    },
    events: {
        get: `${baseUrl}/api/v1/dashboard/events`,
        put: `${baseUrl}/api/v1/dashboard/events/update`,
        post: `${baseUrl}/api/v1/dashboard/events`,
        postAvailability: `${baseUrl}/api/v1/dashboard/events/availability`,
        postTranslation: `${baseUrl}/api/v1/dashboard/events/translation`,
        order: `${baseUrl}/api/v1/dashboard/events/order`,
        delete: `${baseUrl}/api/v1/dashboard/events`,
    },
    books: {
        get: `${baseUrl}/api/v1/dashboard/books`,
        put: `${baseUrl}/api/v1/dashboard/books/update`,
        post: `${baseUrl}/api/v1/dashboard/books`,
        postTranslation: `${baseUrl}/api/v1/dashboard/books/translation`,
        order: `${baseUrl}/api/v1/dashboard/books/order`,
        delete: `${baseUrl}/api/v1/dashboard/books`,
    },
    podcasts: {
        get: `${baseUrl}/api/v1/dashboard/podcasts`,
        put: `${baseUrl}/api/v1/dashboard/podcasts/update`,
        post: `${baseUrl}/api/v1/dashboard/podcasts`,
        postAvailability: `${baseUrl}/api/v1/dashboard/podcasts/availability`,
        postTranslation: `${baseUrl}/api/v1/dashboard/podcasts/translation`,
        order: `${baseUrl}/api/v1/dashboard/podcasts/order`,
        delete: `${baseUrl}/api/v1/dashboard/podcasts`,
    },
    galleries: {
        get: `${baseUrl}/api/v1/dashboard/galleries`,
        put: `${baseUrl}/api/v1/dashboard/galleries/update`,
        post: `${baseUrl}/api/v1/dashboard/galleries`,
        postAvailability: `${baseUrl}/api/v1/dashboard/galleries/availability`,
        postTranslation: `${baseUrl}/api/v1/dashboard/galleries/translation`,
        order: `${baseUrl}/api/v1/dashboard/galleries/order`,
        delete: `${baseUrl}/api/v1/dashboard/galleries`,
    },
    settingsSliderHighlights: {
        get: `${baseUrl}/api/v1/dashboard/settings/highlights`,
        post: `${baseUrl}/api/v1/dashboard/settings/highlights`,
        order: `${baseUrl}/api/v1/dashboard/settings/highlights/order`,
        delete: `${baseUrl}/api/v1/dashboard/settings/highlights`,
    },

    settingsSliderPrograms: {
        get: `${baseUrl}/api/v1/dashboard/settings/programs`,
        post: `${baseUrl}/api/v1/dashboard/settings/programs`,
        order: `${baseUrl}/api/v1/dashboard/settings/programs/order`,
        delete: `${baseUrl}/api/v1/dashboard/settings/programs`,
    },

    settingsSliderInteresteds: {
        get: `${baseUrl}/api/v1/dashboard/settings/interesteds`,
        post: `${baseUrl}/api/v1/dashboard/settings/interesteds`,
        order: `${baseUrl}/api/v1/dashboard/settings/interesteds/order`,
        delete: `${baseUrl}/api/v1/dashboard/settings/interesteds`,
    },

    settingsSliderPodcasts: {
        get: `${baseUrl}/api/v1/dashboard/settings/podcasts`,
        post: `${baseUrl}/api/v1/dashboard/settings/podcasts`,
        delete: `${baseUrl}/api/v1/dashboard/settings/podcasts`,
    },

    form: {
        contacts: {
            get: `${baseUrl}/api/v1/dashboard/forms/contacts`,
        },
        newsletters: {
            get: `${baseUrl}/api/v1/dashboard/forms/newsletters`,
        },
        participants: {
            get: `${baseUrl}/api/v1/dashboard/forms/participants`,
        },
        companyActivities: {
            get: `${baseUrl}/api/v1/dashboard/forms/company-activities`,
        },
        explicitConsentTexts: {
            get: `${baseUrl}/api/v1/dashboard/forms/explicit-consent-texts`,
        }

    },

    eventTypes: {
        get: `${baseUrl}/api/v1/dashboard/event-types`,
    },
    categoryTypes: {
        get: `${baseUrl}/api/v1/dashboard/category-types`,
    },
    contentTypes: {
        get: `${baseUrl}/api/v1/dashboard/content-types`,
    },
    sliderLinkTypes: {
        get: `${baseUrl}/api/v1/dashboard/slider-link-types`,
    },
    galleryCategories: {
        get: `${baseUrl}/api/v1/dashboard/gallery-categories`,
    },
    upload: {
        file: `${baseUrl}/api/v1/dashboard/upload/file`,
        image: `${baseUrl}/api/v1/dashboard/upload/image`,
        imageByUrl: `${baseUrl}/api/v1/dashboard/upload/image/by-url`,

    },
    languages: {
        get: `${baseUrl}/api/v1/dashboard/languages`,
        put: `${baseUrl}/api/v1/dashboard/languages`,
        post: `${baseUrl}/api/v1/dashboard/languages`,
        order: `${baseUrl}/api/v1/dashboard/languages/order`,
        delete: `${baseUrl}/api/v1/dashboard/languages`,
    },

    medias: {
        get: `${baseUrl}/api/v1/dashboard/medias`,
        post: `${baseUrl}/api/v1/dashboard/medias`,
    },

    newsletters: {
        get: `${baseUrl}/api/v1/dashboard/newsletters`,
        post: `${baseUrl}/api/v1/dashboard/newsletters`,
    },

    catalog: {
        categories: {
            get: `${baseUrl}/api/v1/dashboard/catalog/categories`,
            put: `${baseUrl}/api/v1/dashboard/catalog/categories/update`,
            order: `${baseUrl}/api/v1/dashboard/catalog/categories/order`,
            postTranslation: `${baseUrl}/api/v1/dashboard/catalog/categories/translation`
        },
        subCategories: {
            get: `${baseUrl}/api/v1/dashboard/catalog/sub-categories`,
            put: `${baseUrl}/api/v1/dashboard/catalog/sub-categories/update`,
            order: `${baseUrl}/api/v1/dashboard/catalog/sub-categories/order`,
            postTranslation: `${baseUrl}/api/v1/dashboard/catalog/sub-categories/translation`
        },
        brands: {
            get: `${baseUrl}/api/v1/dashboard/catalog/brands`,
            put: `${baseUrl}/api/v1/dashboard/catalog/brands/update`,
            order: `${baseUrl}/api/v1/dashboard/catalog/brands/order`,
            postTranslation: `${baseUrl}/api/v1/dashboard/catalog/brands/translation`
        },
        products: {
            get: `${baseUrl}/api/v1/dashboard/catalog/products`,
            put: `${baseUrl}/api/v1/dashboard/catalog/products/update`,
            order: `${baseUrl}/api/v1/dashboard/catalog/products/order`,
            postTranslation: `${baseUrl}/api/v1/dashboard/catalog/products/translation`

        }
    },
}